import React from 'react';
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react';
import styled from 'styled-components';
import { Fonts, Palette } from '../utils';
import { RiPencilFill } from 'react-icons/ri';
import { Separator } from '../ui/Separator';
import { ReactComponent as MoreButtonIcon } from '../../assets/icons/more_button.svg';

export const StyledTableDropdown = styled(CDropdown)`
  height: 100%;
  width: 100%;
`;

export const StyledTableDropdownToggleButton = styled(CDropdownToggle)`
  box-shadow: none !important;
  font-weight: 900;
  font-size: 20px;
  height: 100%;
  width: 100%;

  &::after {
    display: none;
  }
`;

export const StyledTableDropdownSeparator = React.forwardRef(({ ...props }, ref) => (
  <Separator orientation="horizontal" ref={ref} {...props} />
));

export const StyledTableDropdownToggle = React.forwardRef(({ ...props }, ref) => (
  <StyledTableDropdownToggleButton ref={ref} {...props}>
    <MoreButtonIcon />
  </StyledTableDropdownToggleButton>
));

export const StyledDropdownMenu = styled(CDropdownMenu)`
  padding: 0 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;

  border-radius: 10px;
  background: ${Palette.HAZY_BLUE};
`;

export const StyledDropdownItem = styled(CDropdownItem)`
  padding: 12px 0;

  color: ${Palette.WHITE} !important;
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;

  pointer-events: all !important;
  opacity: ${(props) => (props.disabled ? '50%' : '100%')} !important;

  :hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')} !important;
    background-color: ${Palette.HAZY_BLUE};
    color: ${(props) => (props.disabled ? 'none' : Palette.OCEANIC_60)} !important;

    svg {
      stroke: ${Palette.OCEANIC_60} !important;
    }
  }
`;
